import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecuritySchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-schemes-edit',
	path: '/secure/admin/EditIssueSecurityScheme([!%]?[\\w]*).jspa',
};
